import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Activate the typewriter CSS that is already defined in index.css.
// The old markup only used the class name; it never added the
// is-typing / is-typed states required by the animation.
setTimeout(() => {
  const animated = new WeakSet();

  const typewriterObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || animated.has(entry.target)) return;

        const element = entry.target;
        animated.add(element);
        element.classList.add("is-typing");
        typewriterObserver.unobserve(element);

        window.setTimeout(() => {
          element.classList.remove("is-typing");
          element.classList.add("is-typed");
        }, 3200);
      });
    },
    { threshold: 0.25 }
  );

  const observeTypewriters = () => {
    document
      .querySelectorAll("section h2, .home-typewriter")
      .forEach((element) => {
        if (!animated.has(element)) typewriterObserver.observe(element);
      });
  };

  observeTypewriters();

  const mutationObserver = new MutationObserver(observeTypewriters);
  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}, 0);
